import { useMemo } from 'react';

import { WalletTypeEnum } from '@libs/backend-common';
import { CurrencyType } from '@libs/types';

import { ExchangeBalanceMap } from 'src/types';
import { usePeriod } from './usePeriod';
import { useWalletAssetsDetailed } from './useWalletInfo';

export const useExchangeBalanceGe = () => {
  const { period } = usePeriod();
  const { walletAssets: walletInfoRes } = useWalletAssetsDetailed(
    WalletTypeEnum.NON_ZERO_ASSETS,
    CurrencyType.USD,
    undefined,
    period
  );

  const assetCodeBalanceMap: ExchangeBalanceMap = useMemo(() => {
    if (!walletInfoRes) return {};

    return walletInfoRes.reduce(
      (acc, { amount, code, value, orderingPriority }) => {
        return {
          ...acc,
          [code]: {
            amount: +amount,
            value: +value,
            orderingPriority: orderingPriority || 0,
          },
        };
      },
      {} as ExchangeBalanceMap
    );
  }, [walletInfoRes]);

  return assetCodeBalanceMap;
};
